var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "design",
    class: {
      loading: _vm.loading
    }
  }, [_vm.design ? [_vm.isVideo && !_vm.still ? [_vm.IS_IOS_SAFARI ? _c('picture', [_c('source', {
    attrs: {
      "type": "video/mp4",
      "srcset": _vm.base + _vm.design.key + '_270x378.mp4'
    }
  }), _c('source', {
    attrs: {
      "type": "image/webp",
      "srcset": _vm.base + _vm.design.key + '_200x280.webp'
    }
  }), _c('img', {
    staticClass: "d-block",
    attrs: {
      "width": "100%",
      "type": "image/jpeg",
      "loading": "lazy",
      "decoding": "async",
      "src": _vm.base + _vm.design.key + '_poster_270x378.jpg',
      "alt": _vm.alt
    },
    on: {
      "load": _vm.end,
      "error": _vm.end,
      "abort": _vm.end
    }
  })]) : _c('video', {
    staticClass: "d-block",
    attrs: {
      "width": "100%",
      "playsinline": "",
      "autoplay": "",
      "muted": "",
      "loop": "",
      "poster": _vm.base + _vm.design.key + '_poster_270x378.jpg',
      "src": _vm.base + _vm.design.key + '_270x378.mp4',
      "aria-label": _vm.alt
    },
    domProps: {
      "muted": true
    },
    on: {
      "loadeddata": _vm.end,
      "error": _vm.end,
      "abort": _vm.end
    }
  })] : _c('img', {
    staticClass: "d-block",
    attrs: {
      "width": "100%",
      "loading": "lazy",
      "decoding": "async",
      "src": _vm.base + _vm.design.key + (_vm.isVideo ? '_poster_270x378.jpg' : '_270x378.jpg'),
      "alt": _vm.alt
    },
    on: {
      "load": _vm.end,
      "error": _vm.end,
      "abort": _vm.end
    }
  })] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }